export default "__VITE_ASSET__5a9bd8d3__"